import Textarea from './Textarea';

export default Textarea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-textarea/es/index.js
// module id = 1146
// module chunks = 0